import { type ComponentProps } from 'react';

import { cn } from '@air/utils-tailwind';

export const WORKSPACE_NAV_IMAGE_AVATAR_SIZE = 32;

export type WorkspaceItemProps = ComponentProps<'img'> & {
  image: string;
};

export const WorkspaceNavImage = ({ className, image, ...restOfProps }: WorkspaceItemProps) => {
  return (
    <div className={cn('h-8 w-8 shrink-0 overflow-hidden rounded-6', className)}>
      <img
        alt=""
        className="size-full overflow-hidden object-cover"
        src={`${image}?h=${WORKSPACE_NAV_IMAGE_AVATAR_SIZE * 3}&w=${WORKSPACE_NAV_IMAGE_AVATAR_SIZE * 3}=&fit=crop`}
        {...restOfProps}
      />
    </div>
  );
};
